export const enum RoutePath {
    HomePage = '/',
    Login = '/login',
    Unauthorized = 'error/401',
    NotFound = '/error/404'
}



// WEBPACK FOOTER //
// ./src/routes/RoutePath.ts